import { apiClient } from "@/services/HttpService";

//web端权限设置
export function loadWebPrivilegeConfig(roleId) {
  return apiClient.get(`/privileges/web?roleId=${roleId}`);
}
//web功能授权
export function authoirzeWebFunc(authParams) {
  return apiClient.post("/privileges/web/authorize", authParams);
}
